import DefaultLoader from "./Loaders/DefaultLoader";
import BarChartLoader from "./Loaders/BarChartLoader";
import PieChartLoader from "./Loaders/PieChartLoader";

const LoadingPreview = ({ type = "defailt" }: { type?: string }) => {
  switch (type) {
    case "bar_chart":
      return <BarChartLoader />;
    case "pie_chart":
      return <PieChartLoader />;
    default:
      return <DefaultLoader />;
  }
};

export default LoadingPreview;
